import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { PaymentMethodArea } from "./Styles";

export default function PaymentMethod({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Metodo de pago"
            value={!value ? document.payMethod.description : value}
          />
        </div>
      ) : (
        <PaymentMethodArea>
          <Informative
            readonly={true}
            label="Metodo de pago"
            value={!value ? document.payMethod.description : value}
          />
        </PaymentMethodArea>
      )}
    </>
  );
}
